import React, { Component } from "react";
import axios from 'axios';
import BaseApi from "../../Api/BaseApi";

import {

  AlertError,
} from '../../components/Utility/MyString';

const Product_NGC_Context = React.createContext();
const ServiceApi = BaseApi + "/api/admin/admin_product";

export default class Product_NGC_Provider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userid: '',

      data: {
        code: '',
        name1: '',
        unitcode: 'EA',
        saleprice: 0,
        activestatus: '1',
        salestatus: '1',
        linkurl: '',
        content: ''
      },
      productcode: '',
      itempage: [
        {
          register: '',
          dn_no: '',
          imageurl: '',
          locate: '',
          buyin: '',
          imagename: '',
          price: '',
          totalrecord: 1
        }
      ],
      itemimage: [
        {
          register: '',
          dn_no: '',
          imageurl: '',
          locate: '',
          buyin: '',
          imagename: '',
          price: '',
          totalrecord: 1
        }
      ],
      itempage_carpromotion: [
        {
          register: '',
          dn_no: '',
          imageurl: '',
          locate: '',
          buyin: '',
          imagename: '',
          price: '',
          totalrecord: 1
        }
      ],

      itempage_carnews: [
        {
          register: '',
          dn_no: '',
          imageurl: '',
          locate: '',
          buyin: '',
          imagename: '',
          price: '',
          totalrecord: 1
        }
      ],

      itempage_cartype: [
        {
          id: '',
          name: '',
          nam_th: '',

        }
      ],
      itempage_carfuels: [
        {
          id: '',
          fuel_type: ''

        }
      ],

      itempage_carbrands: [
        {
          id: '',
          name: '',
        }
      ],

      itempage_carmodel: [
        {
          id: '',
          name: '',
        }
      ],

      itempage_carcolor: [
        {
          id: '',
          name: '',
        }
      ],
      itempage_listbranch: [
        {
          branchid: '',
          companyname1: '',
          address: '',
        }
      ],

      itempage_listbranchimage: [
        {
          code: '',
          imagename: '',

        }
      ],
      itempage_listactivityimage: [
        {
          code: '',
          imagename: '',

        }
      ],
      itempage_carimages: [
        {
          code: '',
          imagename: '',

        }
      ],

      itempage_cars: [
        {
          register: '',
          dn_no: '',
          locate: '',
          buyin: '',
          price: '',
          totalrecord: 1
        }
      ],

      itempage_contact: [
        {
          mobilephone: '',
          facebook: '',
          page: '',
          line: '',
          facebook_url: '',
          page_url: '',
        }
      ],


      pageindex: 1,
      pagesize: 9,
      strsearch: '',
      companycode: '01',
      totalrecord: 0,
      totalCarFound: 0,
      maxPrice: 1000000,
      pagecount: 0
    } // end set state

  }// end sonstructore


  setData = async (values) => {
    this.setState({
      ...this.state,
      data: values
    });

    //console.log("state->" + JSON.stringify(this.state))

  };

  setProductUserid = async (xuserid) => {
    this.setState({
      //...this.state,  
      userid: xuserid
    });

    //console.log("state->" + JSON.stringify(this.state))

  };

  firstPage = async (callBack) => {
    this.setState({
      ...this.state,
      pageindex: 1
    })

    let obj = this
    setTimeout(function () {
      //alert("from context->" + obj.state.strsearch);
      obj.getPage(callBack)
    }, 200)

  }

  previousPage = async (callBack) => {
    if (this.state.pageindex === 1) {
      callBack("")
      return;
    }
    this.setState({
      ...this.state,
      pageindex: this.state.pageindex - 1
    })

    let obj = this
    setTimeout(function () {
      //alert("from context->" + obj.state.strsearch);
      obj.getPage(callBack)
    }, 200)

  }

  nextPage = async (callBack) => {

    if (this.state.pageindex === this.state.pagecount) {
      callBack("")
      return;
    }

    this.setState({
      ...this.state,
      pageindex: this.state.pageindex + 1
    })

    let obj = this
    setTimeout(function () {
      //alert("from context->" + obj.state.strsearch);
      obj.getPage(callBack)
    }, 200)

  }

  lastPage = async (callBack) => {
    this.setState({
      pageindex: this.state.pagecount
    });

    let obj = this

    setTimeout(function () {
      //alert("Last Page ...." + obj.state.pageindex)
      obj.getPage(callBack);
    }, 200)

  }

  getPage = async (callBack) => {
    try {

      //alert("product context getpage -> " + this.state.userid);

      let page = {
        pageindex: this.state.pageindex,
        pagesize: this.state.pagesize,
        strsearch: this.state.strsearch,
        companycode: this.state.companycode,
        userid: this.state.userid
      }

      //alert("inbox context get page")

      let url = BaseApi + "/api/admin/product_page";

      //alert("context data->" + JSON.stringify(page));

      await axios.post(url, { data: page, xx: "xxx" })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0

          //AlertError("getpage ->" + JSON.stringify(response.data));

          let objdata = response.data;

          //AlertError("getpage ->" + JSON.stringify(objdata[0].totalrecord));



          let obj = this

          setTimeout(function () {

            if (objdata[0] !== undefined) {
              xpagecount = parseInt(response.data[0].totalrecord / 20);
              ypage = response.data[0].totalrecord % 20;
              if (ypage > 0) { xpagecount = xpagecount + 1 }
              xtotalrecord = response.data[0].totalrecord
            }


            obj.setState({
              ...obj.state,
              itempage: response.data,
              totalrecord: xtotalrecord,
              pagecount: xpagecount
            });
          }, 100)


          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };


  getData = async (id, callBack) => {
    try {

      //message.loading('Please wait ...',2);  
      //alert('get data id=>' + id);
      this.setState({
        ...this.state,
        productcode: id
      });

      //alert("product context -> " + ServiceApi);

      await axios.get(ServiceApi, { params: { id: id } })
        .then((res) => {

          AlertError("context from server->" + JSON.stringify(res.data));

          this.setState({
            ...this.state,
            data: res.data,
          });

          callBack(res.data)
        })


    } catch (error) {
      AlertError(error.message);
      callBack("")
    }
  };

  saveData = async (xdata, callBack) => {

    try {

      //message.loading('Please wait ...',2);      

      await axios.post(ServiceApi, {
        data: xdata
      })
        .then((res) => {
          if (res.data === "true") {
            //AlertCompleSave();

            setTimeout(function () {
              //message.success('Save Data Complete..', 5);
              callBack(true)
            }, 200)

          }
        })


    } catch (error) {
      AlertError(error.message);
      callBack(false)
    }
  }

  updateData = async (xdata, callBack) => {

    try {

      //message.loading('Please wait ...',2);      

      await axios.put(ServiceApi, {
        data: xdata
      })
        .then((res) => {
          if (res.data === "true") {
            //AlertCompleSave();

            setTimeout(function () {
              //message.success('Save Data Complete..', 5);

              callBack(true)
            }, 200)

          }
        })


    } catch (error) {
      AlertError(error.message);
      callBack(false)
    }
  }

  deleteData = async (xdata, callBack) => {

    try {

      //alert("code->" + xdata.code + ' xcode->' + this.state.xtype)

      //message.loading('Action in progress..',1);      

      await axios.delete(ServiceApi, {
        xcode: xdata.xcode,
        code: xdata.code,
        name: xdata.name,
        data: xdata
      })
        .then((res) => {
          if (res.data === "true") {
            setTimeout(function () {
              //message.success('Delete Data Complete..', 5);
              callBack(true)
            }, 200)
          }
        })


    } catch (error) {
      AlertError(error.message);
      callBack(false)
    }
  }

  //function
  componentDidMount() {
    //this.getData();    
  }

  //select changed
  handleChange = (str, callBack) => {
    this.setState({
      //...this.state,
      strsearch: str
    });

    let obj = this
    setTimeout(function () {
      //alert("from context->" + obj.state.strsearch);
      obj.getPage(callBack)
    }, 200)

  }


  PagecheckImage = async (callBack) => {
    try {


      let companycode = sessionStorage.getItem("companycode");
      let userid = sessionStorage.getItem("userid");
      let strsearch = sessionStorage.getItem("strsearch");
      let filter = sessionStorage.getItem("filter");

      let page = {
        pageindex: this.state.pageindex,
        pagesize: this.state.pagesize,
        strsearch: strsearch,
        filter: filter,
        companycode: companycode,
        userid: userid
      }

      // alert("context getPageImage  ->" + JSON.stringify(page));

      let url = BaseApi + "/api/stock/pagecheckimage"

      await axios.post(url, { data: page })
        .then((response) => {


          let xpagecount = parseInt(response.data[0].totalrecord / 20);
          let ypage = response.data[0].totalrecord % 20;
          if (ypage > 0) { xpagecount = xpagecount + 1 }

          let obj = this

          setTimeout(function () {
            obj.setState({
              ...obj.state,

              itempage: response.data,
              totalrecord: response.data[0].totalrecord,
              pagecount: xpagecount

            });
          }, 100)

          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      AlertError(error.message);
      callBack()
    }
  };


  previousPageimage = async (callBack) => {
    if (this.state.pageindex === 1) {
      callBack("")
      return;
    }
    this.setState({
      ...this.state,
      pageindex: this.state.pageindex - 1
    })

    let obj = this
    setTimeout(function () {
      //alert("from context->" + obj.state.strsearch);
      obj.PagecheckImage(callBack)
    }, 200)

  }

  nextPageimage = async (callBack) => {

    if (this.state.pageindex === this.state.pagecount) {
      callBack("")
      return;
    }

    this.setState({
      ...this.state,
      pageindex: this.state.pageindex + 1
    })

    let obj = this
    setTimeout(function () {
      //alert("from context->" + obj.state.strsearch);
      obj.PagecheckImage(callBack)
    }, 200)

  }



  // MygetCarTypes = async (callBack) => {
  //   try {

  //     //alert("product context getpage -> " + this.state.userid);

  //     let page = {

  //       userid: ''
  //     }

  //     //alert("inbox context get page")

  //     let url = BaseApi + "/api/ngc_getCarTypes";


  //     await axios.post(url, { data: page })
  //       .then((response) => {

  //         // AlertError(JSON.stringify(response.data));

  //         // let objdata = response.data;


  //         let obj = this

  //         setTimeout(function () {

  //           // if(objdata[0] !== undefined){
  //           //   xpagecount = parseInt(response.data[0].totalrecord / 20);
  //           //   ypage = response.data[0].totalrecord % 20;
  //           //   if(ypage > 0) { xpagecount = xpagecount + 1}
  //           //   xtotalrecord = response.data[0].totalrecord
  //           // }

  //           obj.setState({
  //             ...obj.state,
  //             itempage_cartype: response.data
  //             // totalrecord: xtotalrecord,
  //             // pagecount: xpagecount
  //           });
  //         }, 100)


  //         setTimeout(function () {
  //           callBack(response.data)
  //         }, 100)

  //       })


  //   } catch (error) {
  //     //AlertError("error->" + error.message);
  //     callBack("")
  //   }
  // };


  // MygetCarBrands = async (callBack) => {
  //   try {

  //     //alert("product context getpage -> " + this.state.userid);

  //     let page = {

  //       carTypeName: sessionStorage.getItem("carTypeName")
  //     }

  //     // alert("MygetCarBrands context  " + page.typeName)

  //     let url = BaseApi + "/api/ngc_getCarBrands";


  //     await axios.post(url, { data: page })
  //       .then((response) => {


  //         // AlertError(JSON.stringify(response.data));

  //         let obj = this

  //         setTimeout(function () {

  //           obj.setState({
  //             ...obj.state,
  //             itempage_carbrands: response.data
  //             // totalrecord: xtotalrecord,
  //             // pagecount: xpagecount
  //           });
  //         }, 100)

  //         setTimeout(function () {
  //           callBack(response.data)
  //         }, 100)

  //       })


  //   } catch (error) {
  //     //AlertError("error->" + error.message);
  //     callBack("")
  //   }
  // };

  MygetCarBrands = async () => {
    try {
      const page = {
        carTypeName: sessionStorage.getItem("carTypeName"),
        companycode: sessionStorage.getItem("companycode"),
      };

      const url = BaseApi + "/api/ngc_getCarBrands";
      const response = await axios.post(url, { data: page });
      const objdata = response.data || [];

      this.setState({
        ...this.state,
        itempage_carbrands: objdata
      });

      return objdata; // ✅ สำคัญสำหรับใช้กับ Promise.all()
    } catch (error) {
      console.error("MygetCarBrands error:", error.message);
      return null;
    }
  };


  MygetCarModel = async (callBack) => {
    try {

      //alert("product context getpage -> " + this.state.userid);

      let page = {

        typeName: sessionStorage.getItem("cartypeName"),
        brandName: sessionStorage.getItem("carBrandName")
      }

      // alert("inbox context  MyGetAPI2")

      let url = BaseApi + "/api/ngc_getCarModels";


      await axios.post(url, { data: page })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0


          let objdata = response.data;

          console.log(objdata)

          //AlertError(JSON.stringify(objdata[0].totalrecord));

          let obj = this

          setTimeout(function () {



            obj.setState({
              ...obj.state,
              itempage_carmodel: response.data
              // totalrecord: xtotalrecord,
              // pagecount: xpagecount
            });
          }, 100)


          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };

  // CarPromotions = async (callBack) => {
  //   try {

  //     //alert("product context getpage -> " + this.state.userid);

  //     let page = {

  //       userid: ''
  //     }

  //     // alert("inbox context  MyGetAPI2")

  //     let url = BaseApi + "/api/ngc_getCarPromotions";


  //     await axios.post(url, { data: page })
  //       .then((response) => {

  //         let xpagecount = 0
  //         let ypage = 0
  //         let xtotalrecord = 0

  //         // AlertError(JSON.stringify(response.data));

  //         // AlertError(response.data);

  //         let objdata = response.data;

  //         console.log(objdata)

  //         //AlertError(JSON.stringify(objdata[0].totalrecord));

  //         let obj = this

  //         setTimeout(function () {

  //           // if(objdata[0] !== undefined){
  //           //   xpagecount = parseInt(response.data[0].totalrecord / 20);
  //           //   ypage = response.data[0].totalrecord % 20;
  //           //   if(ypage > 0) { xpagecount = xpagecount + 1}
  //           //   xtotalrecord = response.data[0].totalrecord
  //           // }

  //           obj.setState({
  //             ...obj.state,
  //             itempage_carpromotion: response.data.cars,
  //             // totalrecord: xtotalrecord,
  //             // pagecount: xpagecount
  //           });
  //         }, 100)


  //         setTimeout(function () {
  //           callBack(response.data)
  //         }, 100)

  //       })


  //   } catch (error) {
  //     //AlertError("error->" + error.message);
  //     callBack("")
  //   }
  // };

  GetCarNews = async (callBack) => {
    try {

      //alert("product context getpage -> " + this.state.userid);

      let page = {

        userid: ''
      }

      // alert("inbox context  MyGetAPI2")

      let url = BaseApi + "/api/ngc_getCarNews";


      await axios.post(url, { data: page })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0

          // AlertError(JSON.stringify(response.data));

          // AlertError(response.data);

          let objdata = response.data;

          console.log(objdata)

          //AlertError(JSON.stringify(objdata[0].totalrecord));

          let obj = this

          setTimeout(function () {

            // if(objdata[0] !== undefined){
            //   xpagecount = parseInt(response.data[0].totalrecord / 20);
            //   ypage = response.data[0].totalrecord % 20;
            //   if(ypage > 0) { xpagecount = xpagecount + 1}
            //   xtotalrecord = response.data[0].totalrecord
            // }

            obj.setState({
              ...obj.state,
              itempage_carnews: response.data.cars,
              // totalrecord: xtotalrecord,
              // pagecount: xpagecount
            });
          }, 100)


          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };


  MyGetAPI6 = async (callBack) => {
    try {

      //alert("product context getpage -> " + this.state.userid);

      let page = {

        carPrototypeId: ''
      }

      // alert("inbox context  MyGetAPI2")

      let url = BaseApi + "/api/ngc_getRelatedCars";


      await axios.post(url, { data: page })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0

          AlertError(JSON.stringify(response.data));

          // AlertError(response.data);

          let objdata = response.data;

          console.log(objdata)

          //AlertError(JSON.stringify(objdata[0].totalrecord));

          let obj = this

          setTimeout(function () {

            // if(objdata[0] !== undefined){
            //   xpagecount = parseInt(response.data[0].totalrecord / 20);
            //   ypage = response.data[0].totalrecord % 20;
            //   if(ypage > 0) { xpagecount = xpagecount + 1}
            //   xtotalrecord = response.data[0].totalrecord
            // }

            obj.setState({
              ...obj.state,
              // itempage : response.data,
              // totalrecord: xtotalrecord,
              // pagecount: xpagecount
            });
          }, 100)


          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };


  MyGetAPI7 = async (callBack) => {
    try {

      //alert("product context getpage -> " + this.state.userid);

      let page = {

        carTypeId: '30',
        carBrandId: 'TOYOTA'
      }

      // alert("inbox context  MyGetAPI2")

      let url = BaseApi + "/api/ngc_getRelatedCarsByTypeExcludeBrand";


      await axios.post(url, { data: page })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0

          AlertError(JSON.stringify(response.data));

          // AlertError(response.data);

          let objdata = response.data;

          console.log(objdata)

          //AlertError(JSON.stringify(objdata[0].totalrecord));

          let obj = this

          setTimeout(function () {

            // if(objdata[0] !== undefined){
            //   xpagecount = parseInt(response.data[0].totalrecord / 20);
            //   ypage = response.data[0].totalrecord % 20;
            //   if(ypage > 0) { xpagecount = xpagecount + 1}
            //   xtotalrecord = response.data[0].totalrecord
            // }

            obj.setState({
              ...obj.state,
              // itempage : response.data,
              // totalrecord: xtotalrecord,
              // pagecount: xpagecount
            });
          }, 100)


          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };


  MyGetAPI10 = async (callBack) => {
    try {

      //alert("product context getpage -> " + this.state.userid);

      let page = {

        carTypeId: '',
        carBrandId: ''
      }

      // alert("inbox context  MyGetAPI2")

      let url = BaseApi + "/api/ngc_getActiveCarBrands";


      await axios.post(url, { data: page })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0

          AlertError(JSON.stringify(response.data));

          // AlertError(response.data);

          let objdata = response.data;

          console.log(objdata)

          //AlertError(JSON.stringify(objdata[0].totalrecord));

          let obj = this

          setTimeout(function () {

            // if(objdata[0] !== undefined){
            //   xpagecount = parseInt(response.data[0].totalrecord / 20);
            //   ypage = response.data[0].totalrecord % 20;
            //   if(ypage > 0) { xpagecount = xpagecount + 1}
            //   xtotalrecord = response.data[0].totalrecord
            // }

            obj.setState({
              ...obj.state,
              // itempage : response.data,
              // totalrecord: xtotalrecord,
              // pagecount: xpagecount
            });
          }, 100)


          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };

  MyGetAPI11 = async (callBack) => {
    try {

      //alert("product context getpage -> " + this.state.userid);

      let page = {

        carTypeId: '',
        carBrandId: ''
      }

      // alert("inbox context  MyGetAPI2")

      let url = BaseApi + "/api/ngc_getActiveCarTypes";


      await axios.post(url, { data: page })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0

          AlertError(JSON.stringify(response.data));

          // AlertError(response.data);

          let objdata = response.data;

          console.log(objdata)

          //AlertError(JSON.stringify(objdata[0].totalrecord));

          let obj = this

          setTimeout(function () {

            // if(objdata[0] !== undefined){
            //   xpagecount = parseInt(response.data[0].totalrecord / 20);
            //   ypage = response.data[0].totalrecord % 20;
            //   if(ypage > 0) { xpagecount = xpagecount + 1}
            //   xtotalrecord = response.data[0].totalrecord
            // }

            obj.setState({
              ...obj.state,
              // itempage : response.data,
              // totalrecord: xtotalrecord,
              // pagecount: xpagecount
            });
          }, 100)


          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };


  fetchCars = async (callBack) => {
    try {

      //alert("product context getpage -> " + this.state.userid);

      let page = {


        carTypeName: sessionStorage.getItem("carTypeName"),
        carBrandName: sessionStorage.getItem("carBrandName"),
        carModelName: sessionStorage.getItem("carModelName"),
        carGear: sessionStorage.getItem("carGear"),
        carFuel: sessionStorage.getItem("carFuel"),
        carColor: sessionStorage.getItem("carColor"),
        maxYear: sessionStorage.getItem("maxYear"),
        minYear: sessionStorage.getItem("minYear"),
        maxPrice: sessionStorage.getItem("maxPrice"),
        maxMileage: sessionStorage.getItem("maxMileage"),
        branchid: sessionStorage.getItem("branchid"),
        isNew: sessionStorage.getItem("isNew"),
        isPromotion: sessionStorage.getItem("isPromotion"),
        searchTerm: sessionStorage.getItem("searchTerm"),
        selectedPage: this.state.pageindex,
        per_page: sessionStorage.getItem("per_page"),
        field: sessionStorage.getItem("field"),
        type: sessionStorage.getItem("type")
      }



      // alert(JSON.stringify(page));

      let url = BaseApi + "/api/ngc_fetchCars";


      await axios.post(url, { data: page })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0
          let per_page = 0


          // alert(JSON.stringify(response.data));

          // AlertError(response.data);

          let objdata = response.data;

          // console.log(objdata)

          //AlertError(JSON.stringify(objdata[0].totalrecord));

          let obj = this

          setTimeout(function () {



            //  alert(JSON.stringify(response.data.totalCarFound));

            if (objdata !== undefined) {
              per_page = response.data.per_page
              xpagecount = parseInt(response.data.totalCarFound / per_page);
              ypage = response.data.totalCarFound % 20;
              if (ypage > 0) { xpagecount = xpagecount + 1 }
              xtotalrecord = response.data.totalCarFound
            }


            obj.setState({
              ...obj.state,
              itempage: response.data.cars,
              // itempage_listimage :   response.data.cars,
              totalrecord: response.data.totalCarFound,
              pagecount: xpagecount
            });
          }, 100)


          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };




  MygetCarColor = async (callBack) => {
    try {

      //alert("product context getpage -> " + this.state.userid);

      let page = {

        typeName: sessionStorage.getItem("cartypeName"),
        brandName: sessionStorage.getItem("carBrandName"),
        modelName: sessionStorage.getItem("carModelName")
      }

      // alert("inbox context  MyGetAPI2")

      let url = BaseApi + "/api/ngc_getCarColor";


      await axios.post(url, { data: page })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0


          let objdata = response.data;

          console.log(objdata)

          //AlertError(JSON.stringify(objdata[0].totalrecord));

          let obj = this

          setTimeout(function () {



            obj.setState({
              ...obj.state,
              itempage_carcolor: response.data
              // totalrecord: xtotalrecord,
              // pagecount: xpagecount
            });
          }, 100)



        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };



  MyGetBranch = async (callBack) => {
    try {



      let companycode = 'NGC';
      let userid = '';
      let strsearch = sessionStorage.getItem("branchid");


      let page = {
        pageindex: this.state.pageindex,
        pagesize: this.state.pagesize,
        strsearch: strsearch,
        companycode: companycode,
        userid: userid
      }



      let url = BaseApi + "/api/ngc_getBranch";


      await axios.post(url, { data: page })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0


          let objdata = response.data;



          //AlertError(JSON.stringify(objdata[0].totalrecord));

          let obj = this

          setTimeout(function () {

            // alert(JSON.stringify(response.data.branchdata));

            obj.setState({
              ...obj.state,
              itempage_listbranch: response.data.branchdata,
              itempage_listbranchimage: response.data.branchimages

              // totalrecord: xtotalrecord,
              // pagecount: xpagecount
            });
          }, 100)


          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };





  MyGetActivity = async (callBack) => {
    try {



      let companycode = 'NGC';
      let userid = '';
      let strsearch = '';


      let page = {
        pageindex: this.state.pageindex,
        pagesize: this.state.pagesize,
        strsearch: strsearch,
        companycode: companycode,
        userid: userid
      }



      let url = BaseApi + "/api/ngc_getactivity";


      await axios.post(url, { data: page })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0


          let objdata = response.data;



          //AlertError(JSON.stringify(objdata[0].totalrecord));

          let obj = this

          setTimeout(function () {

            // alert(JSON.stringify(response.data.branchdata));

            obj.setState({
              ...obj.state,
              // itempage_listactivity: response.data.branchdata,
              itempage_listactivityimage: response.data.activityimages

              // totalrecord: xtotalrecord,
              // pagecount: xpagecount
            });
          }, 100)


          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };


  MyGetCarDetail = async (callBack) => {
    try {




      let searchTerm = sessionStorage.getItem("license")


      let page = {

        searchTerm: searchTerm

      }



      let url = BaseApi + "/api/ngc_getcardetail";


      await axios.post(url, { data: page })
        .then((response) => {

          let xpagecount = 0
          let ypage = 0
          let xtotalrecord = 0


          let objdata = response.data;



          //AlertError(JSON.stringify(objdata[0].totalrecord));

          let obj = this

          setTimeout(function () {

            //  alert(JSON.stringify(response.data));

            obj.setState({
              ...obj.state,

              itempage_cars: response.data.cars,
              itempage_carimages: response.data.carimages,
              itempage_contact: response.data.contact

              // totalrecord: xtotalrecord,
              // pagecount: xpagecount
            });
          }, 100)


          setTimeout(function () {
            callBack(response.data)
          }, 100)

        })


    } catch (error) {
      //AlertError("error->" + error.message);
      callBack("")
    }
  };


  fetchCars_V2 = async (callBack) => {
    try {
      const page = {
        isCertified: sessionStorage.getItem("isCertified"),
        isHotDeal: sessionStorage.getItem("isHotDeal"),
        keyword: sessionStorage.getItem("keyword"),

        minPrice: sessionStorage.getItem("minPrice"),
        maxPrice: sessionStorage.getItem("maxPrice"),
        carTypeName: sessionStorage.getItem("carTypeName"),
        carBrandName: sessionStorage.getItem("carBrandName"),
        carModelName: sessionStorage.getItem("carModelName"),
        carGear: sessionStorage.getItem("carGear"),
        carFuel: sessionStorage.getItem("carFuel"),
        carColor: sessionStorage.getItem("carColor"),
        installmentPeriod: sessionStorage.getItem("installmentPeriod"),
        downPayment: sessionStorage.getItem("downPayment"),
        isNew: sessionStorage.getItem("isNew"),
        isPromotion: sessionStorage.getItem("isPromotion"),
        minYear: sessionStorage.getItem("minYear"),
        maxYear: sessionStorage.getItem("maxYear"),
        selectedPage: sessionStorage.getItem("pageindexNormal") || 1,
        per_page: sessionStorage.getItem("per_page"),
        field: sessionStorage.getItem("field"),
        type: sessionStorage.getItem("type"),
      };

      const url = BaseApi + "/api/ngc_fetchCars_v2";



      const response = await axios.post(url, { data: page });

      // alert("selectedPage: " + page.selectedPage + ", per_page: " + page.per_page);

      const objdata = response.data;
      const per_page = sessionStorage.getItem("per_page") || 20;
      const totalCarFound = objdata.totalCarFound || 0;
      const maxPrice = objdata.maxPrice || 1000000;
      const pagecount = Math.ceil(totalCarFound / per_page);


      sessionStorage.setItem("totalCarFound", totalCarFound.toString()); // ✅ เก็บค่า totalCarFound
      sessionStorage.setItem("pagecount", pagecount.toString()); // ✅ เก็บค่า pagecount



      //  alert("totalCarFound: " + totalCarFound + ", pagecount: " + pagecount + ", maxPrice: " + maxPrice);

      this.setState({
        ...this.state,
        itempage: objdata.cars || [],
        totalCarFound: totalCarFound,
        maxPrice: maxPrice,
        pagecount: pagecount,
      });

      if (typeof callBack === "function") {
        callBack(objdata);
      } else {
        console.warn("callBack is not a function:", callBack);
      }
    } catch (error) {
      console.error("fetchCars_V2 error:", error.message);
      if (typeof callBack === "function") {
        callBack("error fetching cars");
      }
    }
  };

  CarPromotions = async (callBack) => {
    try {
      const page = {
        selectedPage: sessionStorage.getItem("pageindexPromotion") || 1,
        per_page: sessionStorage.getItem("per_page"),
        field: sessionStorage.getItem("field"),
        type: sessionStorage.getItem("type"),
      };

     
      const url = BaseApi + "/api/ngc_getCarPromotions";

      const response = await axios.post(url, { data: page });
      const objdata = response.data || {};
      const cars = objdata.cars || [];

      const per_page = sessionStorage.getItem("per_page") || 20;
      const totalPromotionCars = objdata.totalPromotionCars || 0;
      const pagecountPromotion = Math.ceil(totalPromotionCars / per_page);


      sessionStorage.setItem("totalPromotionCars", totalPromotionCars.toString()); // ✅ เก็บค่า totalPromotionCars
      sessionStorage.setItem("pagecountPromotion", pagecountPromotion.toString()); // ✅ เก็บค่า pagecount

      this.setState({
        ...this.state,
        itempage_carpromotion: cars,
        totalPromotionCars: totalPromotionCars, 
        pagecountPromotion: pagecountPromotion,
      });

      if (typeof callBack === "function") {
        callBack(objdata);
      } else {
        console.warn("callBack is not a function:", callBack);
      }
    } catch (error) {
      console.error("CarPromotions error:", error.message);
      if (typeof callBack === "function") {
        callBack("error");
      }
    }
  };


  MygetCarTypes = async (callBack) => {
    try {
      const page = { userid: '' };
      const url = BaseApi + "/api/ngc_getCarTypes";

      const response = await axios.post(url, { data: page });
      const objdata = response.data || [];

      this.setState({
        ...this.state,
        itempage_cartype: objdata
      });

      if (typeof callBack === "function") {
        callBack(objdata);
      } else {
        console.warn("callBack is not a function:", callBack);
      }
    } catch (error) {
      console.error("MygetCarTypes error:", error.message);
      if (typeof callBack === "function") {
        callBack("");
      }
    }
  };




  MygetCarFuels = async (callBack) => {
    try {
      const page = { userid: '' };
      const url = BaseApi + "/api/ngc_getCarFuels";

      const response = await axios.post(url, { data: page });
      const objdata = response.data || [];

      this.setState({
        ...this.state,
        itempage_carfuels: objdata
      });

      if (typeof callBack === "function") {
        callBack(objdata);
      } else {
        console.warn("callBack is not a function:", callBack);
      }
    } catch (error) {
      console.error("MygetCarFuels error:", error.message);
      if (typeof callBack === "function") {
        callBack("");
      }
    }
  };


  render() {
    return (
      <Product_NGC_Context.Provider
        value={{
          ...this.state,
          handleChange: this.handleChange,
          setData: this.setData,
          setProductUserid: this.setProductUserid,
          saveData: this.saveData,
          updateData: this.updateData,
          getData: this.getData,
          deleteData: this.deleteData,
          getPage: this.getPage,
          firstPage: this.firstPage,
          previousPage: this.previousPage,
          nextPage: this.nextPage,
          lastPage: this.lastPage,

          PagecheckImage: this.PagecheckImage,
          previousPageimage: this.previousPageimage,
          nextPageimage: this.nextPageimage,
          MygetCarTypes: this.MygetCarTypes,
          MygetCarBrands: this.MygetCarBrands,
          MygetCarModel: this.MygetCarModel,
          CarPromotions: this.CarPromotions,
          GetCarNews: this.GetCarNews,
          MyGetAPI6: this.MyGetAPI6,
          MyGetAPI7: this.MyGetAPI7,
          fetchCars: this.fetchCars,
          fetchCars_v2: this.fetchCars_V2,
          MyGetAPI10: this.MyGetAPI10,
          MyGetAPI11: this.MyGetAPI11,
          MygetCarColor: this.MygetCarColor,
          MyGetBranch: this.MyGetBranch,
          MyGetActivity: this.MyGetActivity,
          MyGetCarDetail: this.MyGetCarDetail,
          MygetCarFuels: this.MygetCarFuels,
        }}
      >
        {this.props.children}
      </Product_NGC_Context.Provider>
    );
  }
}
const Product_NGC_Consumer = Product_NGC_Context.Consumer;

export { Product_NGC_Provider, Product_NGC_Consumer, Product_NGC_Context };

export function withProduct_NGC_Consumer(Component) {
  return function ConsumerWrapper(props) {
    return (
      <Product_NGC_Consumer>
        {value => <Component {...props} context={value} />}
      </Product_NGC_Consumer>
    );
  };
}
